export default {
	getHeaders(role) {
		if (role === "author") {
			return {
				field: [
					{ field: "id", 						title: "№" },
					{ field: "name", 					title: "topic" },
					{ field: "chat_messages_count", 	title: "" },
					// { field: "subject", 				title: "subject" },
					// { field: "work_type", 				title: "type" },
					{ field: "pages_number", 			title: "pagesCount" },
					{ field: "milestones", 		title: "milestonesCount" },
					{ field: "price", 			title: "priceEuro" },
					{ field: "due_date", 				title: "dueDate" },
					{ field: "manager.username", 		title: "manager" },
				],
				tabs: [
					{ key: "new", 						title: "new" },
					{ key: "in_progress", 				title: "inProgress" },
					{ key: "waiting_approve",  			title: "waitingApprove" },
					{ key: "completed", 				title: "finished" },
				]
			}
		}

		if (role === "manager") {
			return {
				field: [
					{ field: "id", 						title: "№" },
					{ field: "created", 				title: "date" },
					{ field: "name", 					title: "topic" },
					{ field: "chat_messages_count", 	title: "" },
					{ field: "client",	 				title: "client" },
					// { field: "subject", 				title: "subject" },
					// { field: "work_type",		 		title: "type" },
					// { field: "quality_level", 			title: "level" },
					{ field: "site", 					title: "site" },
					{ field: "pages_number", 			title: "pagesCount" },
					{ field: "due_date", 				title: "dueDate" },
					{ field: "author.username", 		title: "author" },
					{ field: "task", 					title: "task" },
				],
				tabs: [
					{ key: "new", 						title: "new" },
					{ key: "client_not_answer", 		title: "clientNotAnswer" },
					{ key: "processing", 				title: "processing" },
					{ key: "offer_sent", 				title: "offerSent" },
					{ key: "waiting_payment", 			title: "waitingPayment" },
					{ key: "waiting_author", 			title: "waitingAuthor" },
					{ key: "in_progress", 				title: "inProgress" },
					{ key: "waiting_approve", 			title: "waitingApprove" },
					{ key: "completed", 				title: "completed" },
					{ key: "failed_with_payout", 		title: "failedWithPayout" },
					{ key: "failed", 					title: "failed" },
					{ key: "basket", 					title: "basket" },
				]
			}
		}

		if (role === "admin") {
			return {
				field: [
					{ field: "id", 						title: "№" },
					{ field: "created", 				title: "date" },
					{ field: "name", 					title: "topic" },
					{ field: "chat_messages_count", 	title: "" },
					{ field: "client",	 				title: "client" },
					// { field: "subject", 				title: "subject" },
					// { field: "work_type",				title: "type" },
					// { field: "quality_level", 			title: "level" },
					{ field: "site", 					title: "site" },
					{ field: "pages_number", 			title: "pagesCount" },
					{ field: "due_date", 				title: "dueDate" },
					{ field: "author.username", 		title: "author" },
					{ field: "task", 					title: "task" },
				],
				tabs: [
					{ key: "new", 						title: "new" },
					{ key: "client_not_answer", 		title: "clientNotAnswer" },
					{ key: "processing", 				title: "processing" },
					{ key: "offer_sent", 				title: "offerSent" },
					{ key: "waiting_payment", 			title: "waitingPayment" },
					{ key: "waiting_author", 			title: "waitingAuthor" },
					{ key: "in_progress", 				title: "inProgress" },
					{ key: "waiting_approve", 			title: "waitingApprove" },
					{ key: "completed", 				title: "completed" },
					{ key: "failed_with_payout", 		title: "failedWithPayout" },
					{ key: "failed", 					title: "failed" },
					{ key: "basket", 					title: "basket" },
				]
			}
		}
	}
}
